export default (function (_ref) {
  var request = _ref.request;
  return {
    /**
       * @description 订单列表
       * @description http://yapi.xiya.vip/project/11/interface/api/75
       */
    SMS_RECHARGE_ALL: function SMS_RECHARGE_ALL() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/api/sms-recharge/index',
        method: 'post',
        data: query
      });
    },

    /**
       * @description 新闻创建
       * @description http://yapi.xiya.vip/project/11/interface/api/80
       */
    SMS_RECHARGE_CREATE: function SMS_RECHARGE_CREATE(data) {
      return request({
        url: '/api/sms-recharge/create',
        method: 'put',
        data: data
      });
    },

    /**
       * @description 字典详情
       * @description http://yapi.xiya.vip/project/11/interface/api/95
       */
    SMS_RECHARGE_DETAIL: function SMS_RECHARGE_DETAIL(id) {
      return request({
        url: '/api/sms-recharge/update',
        method: 'post',
        data: {
          id: id
        }
      });
    },

    /**
       * @description 字典编辑
       * @description http://yapi.xiya.vip/project/11/interface/api/95
       */
    SMS_RECHARGE_UPDATE: function SMS_RECHARGE_UPDATE(data) {
      return request({
        url: '/api/sms-recharge/update',
        method: 'put',
        data: data
      });
    },

    /**
       * @description 新闻删除
       * @description http://yapi.xiya.vip/project/11/interface/api/90
       */
    SMS_RECHARGE_DELETE: function SMS_RECHARGE_DELETE(id) {
      return request({
        url: '/api/sms-recharge/delete',
        method: 'delete',
        data: {
          id: id
        }
      });
    }
  };
});